import { Divider, List, ListItem, ListItemText } from '@mui/material';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { AppSettings } from '@/Infrastructure/Configuration/types';
import { useAppSelector } from '@reduxStore';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { ActionItemListProps } from '../types';
import CopyContainerAction from '../Actions/CopyContainerAction';
import PriorityAction from '../Actions/PriorityAction';
import ViewAllLegsAction from '../Actions/ViewAllLegsAction';
import ViewAllConsignmentsAction from '../Actions/ViewAllConsignmentsAction';
import ViewDispatchEventsAction from '../Actions/ViewDispatchEventsAction';
import StreetTurnAction from '../Actions/StreetTurn';
import ViewItemLocationHistoryAction from '../Actions/ViewItemLocationHistoryAction';
import ViewDriverRouteAction from '../Actions/ViewDriverRouteAction';
import ManagePickupDeliveryAction from '../Actions/ManagePickupDeliveryAction';
import ManageContainerAvailabilityAction from '../Actions/ManageContainerAvailabilityAction';
import MultiContainerUpdate from '../Actions/MultiContainerUpdate';
import PrintPickupDeliveryReceipts from '../Actions/PrintPickupDeliveryReceipts';
import UpdateScheduledPickupDeliveryAction from '../Actions/UpdateScheduledPickupDeliveryAction';
import RemoveLegAction from '../Actions/RemoveLeg';
import TraceNowAction from '../Actions/TraceNow';
import SetOnSiteAction from '../Actions/SetOnSite';
import InsertHub from '../Actions/InsertHub';

import styles from '../../RenderCell.module.css';

export default function ActionItems(props: ActionItemListProps) {
	const { features } = useAppSelector((state) => state.appSettings as AppSettings);
	const gridApiRef = useGridApiContext();
	const selectedRows = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	// A load with no leg (cancelled, closed/purged, or deleted) would error on its missing leg/row id.
	// If any selected row has no leg, offer no actions at all.
	const hasLoadWithNoLeg = Array.from(selectedRows.values()).some((row) => !(row as DispatchLeg).legId);
	if (hasLoadWithNoLeg) {
		return (
			<List
				className={styles.actions}
				disablePadding
				dense
			>
				<ListItem>
					<ListItemText primary='No actions available for this load.' />
				</ListItem>
			</List>
		);
	}

	return (
		<>
			<PriorityAction />
			<List
				className={styles.actions}
				disablePadding
				dense
			>
				<ViewAllLegsAction />
				<ViewAllConsignmentsAction />
				<ViewDispatchEventsAction />
				<ViewItemLocationHistoryAction />
				{features?.driverRoute && <ViewDriverRouteAction />}
				{features?.streetTurn && <StreetTurnAction />}
				<RemoveLegAction />

				<Divider />

				<ManagePickupDeliveryAction />
				<UpdateScheduledPickupDeliveryAction />
				<ManageContainerAvailabilityAction />
				<MultiContainerUpdate />
				<PrintPickupDeliveryReceipts />

				<Divider />

				<TraceNowAction />
				<SetOnSiteAction />
				<CopyContainerAction onClose={props.onClose} />
				<InsertHub onClose={props.onClose} />
			</List>
		</>
	);
}
